import * as Yup from 'yup';

export const profileSchema = Yup.object({
  first_name: Yup.string().required("First Name is Required!."),
  last_name: Yup.string().required("Last Name is Required!."),
  email: Yup.string().email("Must be a valid email").required("Email Address is Required!."),
  // school: Yup.string().required("School is Required!.")
});
